import React from 'react';
 
// Creating the context object and passing the default values.
const socketContext = React.createContext([]);
 
export default socketContext;